/*
 * TSS Skin Quiz — Central Copy File
 * ------------------------------------------------------------
 * Every string that a user sees in the quiz lives here. Edit freely.
 * Logic lives in tss-quiz.js / tss-quiz-personas.js / tss-quiz-pdp.js, don't touch those.
 *
 * For a human-readable tour of this file, see docs/COPY_SHEET.md
 *
 * Image URLs:
 *   Currently using placehold.co placeholders. Replace with real Shopify CDN URLs
 *   when you upload your photos (Admin -> Content -> Files -> Upload -> copy CDN URL).
 *   Any option with image: null will render as a text-only pill (no photo).
 */
(function () {
  'use strict';

  // Real Shopify CDN asset URLs. Keep this the single place image URLs are defined.
  var IMG = {
    // Q1, skin type
    q1_oily:        'https://cdn.shopify.com/s/files/1/0640/7330/2171/files/Q1_Oily.png?v=1776947120',
    q1_dry:         'https://cdn.shopify.com/s/files/1/0640/7330/2171/files/Q1_dry.png?v=1776947253',
    q1_combination: 'https://cdn.shopify.com/s/files/1/0640/7330/2171/files/Q1_combination.png?v=1776947274',
    q1_normal:      'https://cdn.shopify.com/s/files/1/0640/7330/2171/files/Q1_Normal.png?v=1776947303',

    // Q2 main concern buckets
    q2_active_acne: 'https://cdn.shopify.com/s/files/1/0640/7330/2171/files/Q2_active_breakouts.png?v=1776948181',
    q2_texture:     'https://cdn.shopify.com/s/files/1/0640/7330/2171/files/Q2_texture-bh-wh-op.png?v=1776948183',
    q2_marks:       'https://cdn.shopify.com/s/files/1/0640/7330/2171/files/Q2_Marks.png?v=1776948182',
    q2_irritation:  'https://cdn.shopify.com/s/files/1/0640/7330/2171/files/Q2_Irritated_or_sensitive.png?v=1776948182',
    q2_rosacea:     'https://cdn.shopify.com/s/files/1/0640/7330/2171/files/Q2_Rosacea.png?v=1776948182',

    // Q2 active-breakouts drill
    q2a_red:     'https://cdn.shopify.com/s/files/1/0640/7330/2171/files/Q2_breakouts_-_red_painful.png?v=1776948198',
    q2a_pus:     'https://cdn.shopify.com/s/files/1/0640/7330/2171/files/Q2_breakouts_-_pus_filled_3.jpg?v=1777043957',
    q2a_cystic:  'https://cdn.shopify.com/s/files/1/0640/7330/2171/files/Q2_breakouts_-_cystic_2.png?v=1777043959',
    q2a_small:   'https://cdn.shopify.com/s/files/1/0640/7330/2171/files/Q2_breakouts_-_small_bumps.png?v=1776948198',

    // Q2 texture drill
    q2t_black:   'https://cdn.shopify.com/s/files/1/0640/7330/2171/files/Q2_texture_-_blackheads.png?v=1776948211',
    q2t_white:   'https://cdn.shopify.com/s/files/1/0640/7330/2171/files/Q2_texture_-_whiteheads.png?v=1776948210',
    q2t_uneven:  'https://cdn.shopify.com/s/files/1/0640/7330/2171/files/Q2_texture_-_uneven_texture.png?v=1776948211',
    q2t_pores:   'https://cdn.shopify.com/s/files/1/0640/7330/2171/files/Q2_texture_-_open_pores.png?v=1776948211',

    // UI icons
    avatar: 'https://cdn.shopify.com/s/files/1/0640/7330/2171/files/Solved_v.svg?v=1776950553',
    am:     'https://cdn.shopify.com/s/files/1/0640/7330/2171/files/AM_icon_2e724d08-6ce4-49f8-8750-a327dd465de0.svg?v=1776950490',
    pm:     'https://cdn.shopify.com/s/files/1/0640/7330/2171/files/PM_icon_3a715b63-913d-4e20-946a-02aafacabba5.svg?v=1776950490'
  };
  // Expose so other files (widget liquid via JS) can pick up the same URLs
  window.TSSQuizAssets = IMG;

  window.TSSQuizCopy = {
    // =========================================================
    // GREETING
    // =========================================================
    greeting: [
      "Hi 👋 I'm your TSS skin guide. Tell me a little about your skin and I'll put together a routine that's actually built for it.",
      "Takes about 60 seconds. Just so you know, this is personalised guidance, not a substitute for a dermatologist."
    ],

    // =========================================================
    // RETURNING USER
    // =========================================================
    returning: [
      "Welcome back 👋 Your routine is saved and ready whenever you need it.",
      "Pick up where you left off, or start fresh if your skin's been through some changes."
    ],
    returning_cta_view: "See my routine →",
    returning_cta_retake: "Start over (my skin has changed)",

    // =========================================================
    // COMPUTING TRANSITION
    // =========================================================
    computing: [
      "Reading through your answers…",
      "Matching your profile to our routine logic. Every recommendation has a reason behind it.",
      "Almost there. Putting your routine together now."
    ],
    computing_final: "Your routine is ready. Opening it now.",

    // =========================================================
    // QUESTION FLOW
    // =========================================================
    questions: {
      // ---- Q1: Skin type ----
      q1: {
        prompt: "Let's start with the basics. How does your skin behave most days?",
        options: [
          { value: 'oily',        label: 'Oily',        image: IMG.q1_oily },
          { value: 'dry',         label: 'Dry',         image: IMG.q1_dry },
          { value: 'combination', label: 'Combination', image: IMG.q1_combination },
          { value: 'normal',      label: 'Normal',      image: IMG.q1_normal },
          { value: 'not_sure',    label: "Not sure yet", image: null }
        ],
        helper: {
          title: 'Not sure which one is you? Here\'s how to tell.',
          body: [
            "<strong>Oily</strong>. Your skin looks shiny by mid-morning, even without applying anything. Pores tend to be visible, and makeup doesn't stay in place for long.",
            "<strong>Dry</strong>. Skin feels tight or a little rough after washing, sometimes flaky around the nose or forehead. It rarely looks shiny.",
            "<strong>Combination</strong>. Oily through the T-zone (forehead, nose, chin) but normal or dry everywhere else. This is actually the most common type.",
            "<strong>Normal</strong>. No real shine, no tightness, no dryness. Your skin mostly just behaves.",
            "Still not sure? Go with <em>Not sure yet</em>. We'll treat you as Combination, which works for most skin. You can always come back and update this."
          ]
        }
      },

      // ---- Q2 MAIN: primary concern buckets ----
      q2_main: {
        prompt: "What's your skin dealing with right now? Pick everything that feels like you.",
        options: [
          { value: 'active_acne',  label: 'Active breakouts',         hint: 'Pimples that are red, swollen, painful, or just keep coming back',       image: IMG.q2_active_acne,  drill: 'q2_active' },
          { value: 'texture',      label: 'Blackheads & texture',     hint: 'Clogged pores, bumpy patches, or skin that doesn\'t feel smooth',        image: IMG.q2_texture,      drill: 'q2_texture' },
          { value: 'marks',        label: 'Dark marks & pigmentation',hint: 'The flat, discoloured spots that pimples leave behind, even after they\'ve healed', image: IMG.q2_marks,     drill: null, adds: ['post_acne_marks'] },
          { value: 'irritation',   label: 'Irritated or sensitive',   hint: 'Skin that stings, turns red, or overreacts to products easily',          image: IMG.q2_irritation,    drill: null, adds: ['irritated_sensitive'] },
          { value: 'rosacea',      label: 'Rosacea',                  hint: 'Skin that flushes easily or stays persistently red, especially on the cheeks', image: IMG.q2_rosacea,   drill: null, adds: ['rosacea'] },
          { value: 'maintenance',  label: 'Just maintenance',         hint: "No major concerns. I just want to keep my skin in good shape",           image: null,                drill: null, adds: ['maintenance'] }
        ],
        helper: {
          title: 'Not sure which applies?',
          body: [
            "<strong>Active breakouts</strong>. Any kind of pimple that's currently there.",
            "<strong>Blackheads & texture</strong>. Clogged pores, uneven skin, bumps that aren't inflamed.",
            "<strong>Dark marks</strong>. Brown or red marks that stay after pimples heal.",
            "<strong>Irritated or sensitive</strong>. If most products sting or your skin reacts a lot.",
            "<strong>Rosacea</strong>. Persistent redness, cheeks flush easily.",
            "Pick multiple if multiple apply."
          ]
        }
      },

      // ---- Q2 DRILL-DOWNS ----
      q2_active: {
        prompt: "Tell us a bit more. What do your breakouts usually look like? Pick all that apply.",
        options: [
          { value: 'red_painful_pimples',     label: 'Red, painful pimples',      hint: "Inflamed, tender to touch. The ones that hurt before they're even visible",                image: IMG.q2a_red },
          { value: 'pus_filled_acne',         label: 'Pus-filled pimples',        hint: 'A white or yellow tip, usually sitting on a red, swollen base',                            image: IMG.q2a_pus },
          { value: 'large_cystic_pimples',    label: 'Deep or cystic',            hint: 'Large, hard lumps under the skin. No visible head, often linger for weeks',                 image: IMG.q2a_cystic },
          { value: 'small_white_red_pimples', label: 'Small whiteheads or bumps', hint: 'Tiny white or skin-coloured bumps, mostly closed. Not painful, but persistent',             image: IMG.q2a_small }
        ]
      },

      q2_texture: {
        prompt: "Which of these sounds most like what you're dealing with? Pick all that apply.",
        options: [
          { value: 'blackheads',      label: 'Blackheads',             hint: 'Dark dots, usually on the nose, chin, or forehead. Pores that are open and clogged',                    image: IMG.q2t_black },
          { value: 'whiteheads',      label: 'Whiteheads',             hint: 'Small bumps with a white top. Clogged pores that are closed over',                                      image: IMG.q2t_white },
          { value: 'uneven_texture',  label: 'Uneven texture',         hint: 'Skin that feels rough or bumpy when you run your fingers across it, even without visible pimples',     image: IMG.q2t_uneven },
          { value: 'open_pores',      label: 'Open or enlarged pores', hint: 'Pores that look bigger than they should, especially around the nose and cheeks',                        image: IMG.q2t_pores }
        ]
      },

      // ---- Q2b: free text ----
      q2b: {
        prompt: "Anything else you want to add? Tell us in your own words what your skin's been going through lately. (optional)",
        placeholder: "e.g. I keep getting painful pimples along my jawline before my period, and nothing I've tried has really helped..."
      },

      // ---- Q3: frequency ----
      q3: {
        prompt: "How often are you dealing with active breakouts?",
        options: [
          { value: 'almost_always',  label: 'Almost always',                      image: null },
          { value: 'every_now_then', label: 'Every few weeks',                    image: null },
          { value: 'once_a_month',   label: 'Around my period, or once a month',  image: null },
          { value: 'rarely',         label: 'Rarely, only occasionally',          image: null }
        ],
        helper: {
          title: 'Not sure?',
          body: ["Think back over the last three months. How many weeks did your skin feel mostly clear? Pick what fits closest."]
        }
      },

      // ---- Q4: triggers ----
      q4: {
        prompt: "Do you have a sense of what tends to bring on your breakouts? (optional, pick any that feel relevant)",
        options: [
          { value: 'hormonal_history', label: 'Hormonal patterns',        hint: 'Breakouts that arrive predictably, around your period, or linked to hormonal shifts',        image: null },
          { value: 'hormonal_recent',  label: 'Recent hormonal changes',  hint: 'Something recent has changed. New contraception, PCOS, a shift in your cycle',             image: null },
          { value: 'lifestyle',        label: 'Stress, food, or sleep',   hint: 'Breakouts that seem to show up when life gets busy, sleep gets short, or diet shifts',     image: null },
          { value: 'environment',      label: 'Sweat, heat, or pollution',hint: 'Skin that reacts after working out, being outdoors, or in polluted environments',          image: null },
          { value: 'not_sure',         label: "Honestly not sure",        hint: 'No obvious pattern. They just seem to show up',                                              image: null }
        ]
      },

      // ---- Q5: makeup ----
      q5: {
        prompt: "Do you wear makeup on a regular basis?",
        options: [
          { value: 'yes_daily',  label: 'Yes, most days',    image: null },
          { value: 'sometimes',  label: 'Sometimes',         image: null },
          { value: 'no_rarely',  label: 'Rarely or never',   image: null }
        ]
      },

      // ---- Q6: sensitivity (optional) ----
      q6: {
        prompt: "How does your skin usually respond to new products? (optional)",
        // Photo path, when the photo showed clear redness. Redness alone is
        // not sensitivity, so it is mentioned here rather than assumed.
        prompt_photo_redness: "Your photo showed some redness. That can just be inflamed spots, so tell us: how does your skin usually respond to new products? (optional)",
        options: [
          { value: 'not',   label: 'Rarely reacts',        hint: "Most things are fine. I don't think of myself as sensitive",                 image: null },
          { value: 'a_bit', label: 'Sometimes reacts',     hint: 'New products occasionally sting, redden, or cause a breakout. I have to be careful', image: null },
          { value: 'very',  label: 'Reacts to most things',hint: 'My skin is easily irritated. Most products cause some kind of reaction',      image: null }
        ]
      },

      // ---- Photo fork, the FIRST thing asked (v2) ----------------------
      // Offered before Q1. Both routes are equal, and the questions route is
      // exactly the v1 quiz. Only shown when the vision Worker answers its
      // health check, so a broken backend means this never appears.
      photo_intro: {
        prompt: "Two ways to do this. Which suits you?",
        sub: "A photo is quicker and lets us see what's actually there. The questions work just as well if you'd rather not.",
        options: [
          { value: 'photo',     label: 'Start with a photo', hint: 'One to three photos, then a few quick questions', image: null },
          { value: 'questions', label: 'Answer questions',   hint: 'Five quick questions, no photo needed',        image: null }
        ]
      },

      // ---- What we read back, for them to confirm or correct -------------
      // Every concern row is always shown. Where the photo was confident the
      // answer is pre-set and they can change it. Where it couldn't tell, they
      // answer it themselves, so nothing is ever assumed from a blank read.
      photo_confirm: {
        // The card has up to two parts: what the photo showed (pre-filled,
        // changeable) and what it couldn't show clearly (they answer).
        // Every row is a question whose answers say what they mean, so
        // agreeing with the photo can never be read as the opposite.
        prompt_mixed: "Done. Here's what we could see. A few things were hard to see in your photo, so those are over to you.",
        prompt_mixed_multi: "Done. Here's what we could see. A few things were hard to see in your photos, so those are over to you.",
        prompt_all_seen: "Done. Here's what we could see. Change anything that's off.",
        section_seen: "From your photo",
        section_seen_multi: "From your photos",
        section_seen_sub: "Tap to change anything that's off.",
        section_open: "Needs your answer",
        section_open_sub: "These were hard to see in your photo.",
        section_open_sub_multi: "These were hard to see in your photos.",
        seen_prefix: "Your photo:",
        seen_prefix_multi: "Your photos:",
        changed_note: "You changed this.",
        need_answer_one: "1 more to answer.",
        need_answer_many: "{n} more to answer.",
        // What the photo saw, as it reads after "Your photo:".
        seen_values: {
          none:     'nothing obvious',
          mild:     'a few, here and there',
          moderate: 'clearly visible',
          marked:   'quite a lot'
        },
        seen_skin: {
          oily: 'looks oily', dry: 'looks dry',
          combination: 'looks like combination skin', normal: 'looks balanced'
        },
        // One question per row. yes/no are the answer buttons.
        rows: {
          skin_type: {
            question: "Your skin type",
            help: "How it behaves most days."
          },
          active_acne: {
            question: "Do you get breakouts?",
            help: "Pimples that come and go, or stick around.",
            timeframe: "Think of a typical month, not just today.",
            yes: "Yes, I get them",
            no: "No, not really"
          },
          marks: {
            question: "Dark marks from old pimples?",
            help: "Flat brown or dark spots.",
            yes: "Yes, I have marks",
            no: "No marks"
          },
          texture: {
            question: "Bumps, blackheads or rough patches?",
            help: "Clogged pores, or skin that doesn't feel smooth.",
            yes: "Yes, I have these",
            no: "No, it's smooth"
          }
        },

        // Older card, kept so a mismatched tss-quiz.js still has its strings.
        prompt: "Here's what we could see. Change anything that's off, and answer for a typical week, not just today.",
        note: "A few quick questions after this, then your routine.",
        // Shown under the rows while any of them still needs an answer.
        need_answer: "Answer the highlighted rows to continue.",
        photo_prefix: "Photo:",
        photo_prefix_multi: "Photos:",
        yes: "Yes",
        no: "No",
        cta_accept: "Looks right",
        cta_continue: "Continue",
        divert_label: "I'd rather answer all the questions myself",
        echo_edited: "Checked and updated",
        // Shown on the card when a side photo was dropped. {views} is e.g.
        // "left side" or "left side and right side".
        views_dropped_one: "We couldn't use your {views} photo, so this read comes from the others.",
        views_dropped_many: "We couldn't use your {views} photos, so this read comes from the front.",
        view_names: { front: "front", left: "left cheek", right: "right cheek" },
        // Row labels. Each is answered Yes or No (skin type picks a type).
        labels: {
          skin_type:   'Skin type',
          active_acne: 'Active breakouts',
          marks:       'Marks left behind',
          texture:     'Bumps, blackheads or rough texture',
          // Answering Yes puts them on the go-slow, sensitive-skin routine,
          // so the row asks about reactivity, not just colour. Redness in a
          // photo is often just inflamed spots.
          redness:     'Skin that goes red or stings easily'
        },
        // What the photo saw, for the redness row only.
        redness_seen: {
          moderate: 'Some visible redness',
          marked:   'A lot of visible redness'
        },
        // Density band -> plain English, per field.
        values: {
          none:     'Nothing obvious',
          mild:     'A few, here and there',
          moderate: 'Clearly there',
          marked:   'Quite a lot',
          unknown:  "Couldn't tell"
        },
        skin_types: {
          oily: 'Oily', dry: 'Dry', combination: 'Combination',
          normal: 'Normal', not_sure: 'Not sure', uncertain: "Couldn't tell from the photo"
        },
        options: [
          { value: 'accept', label: 'Looks right',                    hint: 'Carry on from here',                image: null },
          { value: 'divert', label: 'Not quite, let me answer instead', hint: 'Go through the questions yourself', image: null }
        ],
        // Shown instead of the summary when the photo told us almost nothing.
        thin: "The photo didn't tell us much on its own, so let's go through the questions instead. It still helps, and you'll see what we could make out on your results.",
        echo_accept: "Looks right",
        echo_divert: "I'll answer the questions",
        divert_note: "No problem. Your answers will decide the routine. If the photo saw anything differently, you'll see exactly where on your results."
      },

      // ---- Photo step (optional, v2) ----------------------------------
      // Runs after Q6. Everything here is skippable, and skipping leaves the
      // result identical to v1. Retake lines name the FIX, never the fault,
      // because the subject is the customer's own face.
      photo: {
        prompt: "Good choice. A photo lets us see what's actually there, not just what you can put into words.",
        sub: "Takes under a minute.",
        privacy: "Your photo is analysed and then discarded. Nothing is kept on our side. A small copy stays on your own device so you can see it next to your results.",
        options: [
          { value: 'yes', label: 'Add a photo',            hint: null, image: null },
          { value: 'no',  label: 'Skip, show my routine',  hint: null, image: null }
        ],

        // Shown after they say yes, before the camera opens.
        consent_title: "Two quick confirmations first.",
        consent_analyse: "I agree to my photo being analysed to personalise my routine. It is not kept on your servers, and the small copy shown with my results stays on this device.",
        consent_age: "I am 18 or older.",
        consent_cta: "Continue",
        consent_back: "Actually, skip this",

        capture_title: "Three things make most of the difference:",
        capture_tips: [
          "Face a window. Daylight beats a ceiling light.",
          "Bare skin if you can. Makeup hides what matters.",
          "Hair back and glasses off."
        ],
        // Older single-photo layout only.
        capture_cta: "Open camera",
        capture_upload: "Choose a photo",
        capture_skip: "Skip this",

        // The photo tiles. Front is needed, the sides are optional. Tapping a
        // tile opens the phone's own camera-or-gallery choice.
        capture_views: {
          front: { label: "Front",       sub: "Needed",
                   how: "Look straight at the camera, face filling most of the frame." },
          left:  { label: "Left cheek",  sub: "Optional",
                   how: "Turn your head to the right, so your left cheek faces the camera." },
          right: { label: "Right cheek", sub: "Optional",
                   how: "Turn your head to the left, so your right cheek faces the camera." }
        },
        // The two choices under the tiles, for whichever tile is selected.
        // Same pair as the old single-photo screen: camera, or gallery.
        capture_action_title: "{view} photo",
        capture_take: "Take a photo",
        capture_pick: "Choose a photo",
        capture_cancel: "Cancel",
        // Shown under the tiles, and it changes as they add photos.
        capture_hint_single: "One clear photo is all we need.",
        capture_hint_start: "The cheek photos are optional, but they show your cheeks and jawline far better than a front photo can.",
        capture_hint_more: "Front done. For a more accurate read, tap a cheek above to add it.",
        capture_hint_all: "All three in. Ready when you are.",
        // After a retake: the side photos were fine and are kept.
        capture_hint_front_again: "Your other photos are kept. Just retake the front, looking straight at the camera.",
        capture_read_one: "Read my photo",
        capture_read_many: "Read my {n} photos",
        capture_change: "Change",
        capture_checking: "Checking",
        // {view} is the tile name, {message} one of the retake lines below.
        capture_slot_error: "{view} photo: {message}",

        reading: "Reading your photo.",
        reading_multi: "Reading your photos.",
        reading_steps: [
          "Looking at the surface.",
          "Checking zone by zone.",
          "Putting it together."
        ],

        // One line per reason code the Worker or the on-device checks return.
        retake: {
          too_dark:         "A bit dark to read properly. Turn toward a window or a lamp and go again.",
          too_bright:       "The light is washing out the detail. Step out of direct sun and take another.",
          too_blurry:       "That one came out soft. Hold still for a second and try again.",
          too_small:        "That image is a little small to read. A photo straight from your camera works best.",
          too_far:          "You're a bit far from the camera. Bring it closer so your face fills the frame.",
          no_face:          "Couldn't find a face in that one. Straight on, whole face in the frame.",
          multiple_faces:   "More than one face in that shot. Just you this time.",
          face_obscured:    "Part of your face is covered. Push your hair back and try again.",
          makeup_or_filter: "Looks like makeup or a filter is on. Bare skin gives a truer read.",
          not_a_face:       "That doesn't look like a face photo. A straight-on selfie is what works.",
          appears_under_18: "We can only read photos of adults, and this one looked younger. If that's wrong, try another photo, straight on and in good light. Or tap Skip and answer the questions instead.",
          unreadable:       "Something went wrong opening that file. Try a different photo.",
          fallback:         "That one didn't quite work. Try once more."
        },

        // Both of these end in a full routine. Nobody is ever left without one.
        give_up: "No luck with the camera today. Your answers are plenty to build on, so let's go with those. You can always send a photo on WhatsApp after you order.",
        failed: "Couldn't read that one properly. Your answers are plenty to build on, so let's carry on.",

        // The single reconcile question. Only ever about active acne.
        reconcile: {
          clear: {
            prompt: "One thing worth checking. Your skin looks clear in this photo, which is good news. Which is closer?",
            options: [
              { value: 'still_breaks_out', label: 'Good day. I do break out',  hint: 'Keep treating the breakouts',        image: null },
              { value: 'past_breakouts',   label: 'Mostly past the breakouts', hint: 'Focus on what they left behind',     image: null }
            ]
          },
          visible: {
            prompt: "One thing worth checking. There are some active spots in this photo that you didn't mention. Want those treated too?",
            options: [
              { value: 'treat_it',       label: 'Yes, treat them',           hint: 'Adds an acne treatment to your routine', image: null },
              { value: 'unusual_for_me', label: "No, that's unusual for me", hint: 'No acne treatment added',                image: null }
            ]
          }
        },

        echo_added: "Photo added",
        echo_added_multi: "{n} photos added",
        echo_skipped: "Skipped the photo"
      },

      // ---- Q7: tried before (optional) ----
      q7: {
        prompt: "What have you already tried for your skin? (optional, pick any that apply)",
        options: [
          { value: 'prescription', label: 'Prescription treatments',  hint: 'Antibiotics, retinoids, or anything from a dermatologist',                     image: null },
          { value: 'otc',          label: 'OTC creams or serums',     hint: 'Salicylic acid, benzoyl peroxide, niacinamide. The kind you buy without a prescription', image: null },
          { value: 'home',         label: 'DIY or home remedies',     hint: 'Turmeric, tea tree, aloe. Anything you put together yourself',                 image: null },
          { value: 'nothing',      label: 'Nothing specific yet',     hint: 'No targeted treatment. Just regular skincare or whatever was available',       image: null },
          { value: 'everything',   label: "I've tried everything 😅", hint: 'Multiple products, routines, maybe a dermatologist. Still looking for what actually works', image: null }
        ]
      },

      // ---- Contact capture ----
      contact: {
        prompt: "One last thing. Share your WhatsApp number so we can stay in touch and help you along the way. Email is optional.",
        phone_placeholder: "Your WhatsApp number",
        email_placeholder: "Your email",
        submit: "Send me my routine",
        skip: "" // phone is compulsory, no skip
      }
    },

    // =========================================================
    // ACKNOWLEDGMENTS (variants, picked at random per answer)
    // =========================================================
    acknowledgments: {
      q1: {
        oily: [
          "Oily skin noted. We'll keep things light and balanced. Nothing that'll sit heavy on your skin.",
          "Got it. Oily skin ages well, we'll work with that rather than strip it."
        ],
        dry: [
          "Dry skin noted. We'll lean on hydration, and be careful with how we introduce actives.",
          "Got you. Dry and acne-prone needs a different playbook than oily. We'll treat yours properly."
        ],
        combination: [
          "Combination noted. We'll build a routine that works across zones without overdoing it on either.",
          "Got it. Combination is the most common type, so we have plenty of practice here."
        ],
        normal: [
          "Normal skin. Nice. The focus will be on keeping it that way.",
          "Noted. Normal skin lets us be more targeted with what we add."
        ],
        not_sure: [
          "No problem. We'll go with Combination, which is a safe baseline for most people. You can update this any time."
        ]
      },
      q3: {
        almost_always:  [
          "That's a lot to be managing. A consistent daily approach is the right call. We'll keep it straightforward.",
          "Persistent breakouts need a steady daily routine, not a reactive one. That's exactly what we'll build."
        ],
        every_now_then: [
          "Breakouts that show up in waves. A reliable daily base, plus something targeted for when things flare.",
          "On and off. We'll set you up with a routine that handles both the quiet weeks and the active ones."
        ],
        once_a_month: [
          "Sounds like it may be cycle-related. A gentle daily routine, with the right backup ready for when it hits.",
          "A calm everyday base, plus a targeted step for those specific weeks. That's the plan."
        ],
        rarely: [
          "Good to hear. A light, consistent daily base and something dependable for the odd breakout.",
          "Even occasional breakouts are worth having a proper plan for. We'll keep it simple and effective."
        ]
      },
      q5: {
        yes_daily: [
          "Noted. Thorough makeup removal at the end of the day makes a real difference for acne-prone skin. We'll include it in your routine.",
          "Good to know. A gentle, effective remover is one of the most underrated steps for skin that breaks out. We'll add it in."
        ],
        sometimes: [
          "Got it. We'll include a remover for the days you do wear it. Worth having in the routine.",
          "Makes sense. A gentle remover for those days will help keep things clean without overcomplicating your routine."
        ],
        no_rarely: [
          "One fewer step to think about. Your routine stays leaner for it.",
          "Noted. We'll keep things clean and simple."
        ]
      }
    },

    // =========================================================
    // Q2 RESPONSES (first match wins)
    // =========================================================
    q2_responses: [
      { when: 'has_fungal',         text: "Fungal acne changes the approach a little. We'll lean on azelaic acid, which is well-suited for this and gentle on your skin." },
      { when: 'has_rosacea',        text: "Rosacea noted. We'll keep things calm and anti-inflammatory. Nothing that's likely to upset sensitive skin." },
      { when: 'has_irritation',     text: "Sensitive skin first. We'll prioritise barrier repair. Once your skin feels more settled, we can build from there." },
      { when: 'has_acne_and_marks', text: "Active breakouts and marks. So we're working on two things at once, clearing what's there and fading what's been left behind." },
      { when: 'has_acne',           text: "Understood. We'll target these directly, without overloading you with products you don't need." },
      { when: 'has_marks',          text: "Marks respond really well to the right ingredient, used consistently. Azelaic acid is a good place to start, effective and gentle." },
      { when: 'default',            text: "Got it. We'll build your routine around what's bothering you most." }
    ],

    q2b_response_filled: "Thank you for sharing that. The more context we have, the more tailored your routine, and our follow-up support, can be.",
    q2b_response_empty:  "No worries. We have enough to build something good.",

    // =========================================================
    // OUTPUT PAGE COPY
    // =========================================================
    output: {
      hero_badge: 'Your personalised routine',

      post_purchase_note: "After your order, you'll receive usage instructions & guidance.We'll also be here to address any concerns.If anything comes up while you're using the routine, reach out and we'll help you figure it out. You're never left on your own.",

      // "What we can see" block (v2). Renders directly above the
      // acknowledgement, only when a photo was read successfully. Never a
      // score, never a grade, never a concern they did not come here for.
      findings: {
        eyebrow: "What we can see",
        heading: "From your photo",
        heading_multi: "From your {n} photos",
        disclaimer: "A visual read, not a medical diagnosis.",
        matched: "This lines up with what you told us.",

        // Shown once per concern the photo added that they had not picked.
        added_intro: "Also visible in your photo, though you didn't mention it:",
        added_label: {
          marks:       "Marks left behind by older breakouts",
          texture:     "Congestion and uneven texture",
          irritation:  "Redness and irritation",
          active_acne: "Active breakouts",
          maintenance: "Nothing active to treat right now"
        },
        added_note: "Your routine has been adjusted accordingly.",

        // {type} is replaced with oily / dry / combination / normal.
        skin_type_line: "You weren't sure about your skin type. From the photo it reads as {type}, so the routine is built for that.",
        removed_line: "You told us the breakouts have mostly settled, so this routine focuses on what they left behind.",

        // Photo-first path, customer said "Looks right". These came FROM the
        // photo and they agreed, so never describe them as things they
        // "didn't mention".
        confirmed_line: "You confirmed what the photo showed, so your routine is built on it.",

        // Photo-first path, customer checked the card and answered or changed
        // at least one row. Where they changed something the photo saw, the
        // differs block lists it with lead_edited. Where they only filled in
        // what the photo couldn't see, this line is shown instead.
        edited_line: "Your routine is built on what the photo showed, plus your own answers for the rest.",

        // Photo-first path, customer said "Not quite" and answered for
        // themselves. Their answers decide the routine. Every disagreement is
        // listed, because the customer deserves to know the photo saw it
        // differently rather than finding out later.
        differs: {
          heading: "Where the photo saw it differently",
          lead: "You chose to answer for yourself, so your routine follows your answers, not the photo. Here's where the two didn't match.",
          lead_edited: "You changed some of what the photo showed, so your routine follows your answers. Here's where the two didn't match.",
          // {photo} and {theirs} are replaced with plain skin-type words.
          skin_type: "The photo read your skin as {photo}. You told us it's {theirs}, so the routine is built for {theirs} skin.",
          active_acne_present: "The photo showed active breakouts, which you didn't include. Your routine doesn't treat breakouts. If they're there most days, retake the quiz and add them.",
          active_acne_absent: "Your skin looked clear of active breakouts in the photo, but you told us you get them, so your routine treats them. One photo is one day.",
          marks_present: "The photo showed some marks you didn't include, so your routine doesn't target them.",
          marks_absent: "The photo didn't pick up marks, but you told us you have them, so your routine treats them.",
          texture_present: "The photo showed congestion and uneven texture, which you didn't include, so your routine doesn't target it.",
          texture_absent: "The photo didn't pick up uneven texture, but you told us it's there, so your routine treats it.",
          redness_present: "The photo showed some redness. You didn't tell us your skin is sensitive, so the go-slow steps aren't in your routine. If anything stings, introduce each product one at a time.",
          skin_words: { oily: "oily", dry: "dry", combination: "combination", normal: "normal" }
        },
        removed_line_clear: "You told us the breakouts have mostly settled, and there is nothing active to treat in the photo. This routine keeps your skin steady rather than treating anything.",

        // Shown when the read flags something that needs a person, not a cart.
        refer: {
          eyebrow: "Worth a conversation",
          body: "Some of what's in your photo is better handled by a person than a product page. Message us on WhatsApp before you order and we'll talk it through."
        },

        // Second offer, for people who skipped the photo in the quiz.
        reoffer: {
          eyebrow: "Optional",
          heading: "Want us to check this against a photo?",
          body: "Adding a photo lets us tell you what we can see, and adjust the routine if it changes anything. It is analysed and then discarded, with nothing kept on our side.",
          cta: "Add a photo",
          reading: "Reading your photo."
        }
      },

      // Barrier-first protocol disclaimer. Shown ONLY when the user flagged
      // sensitive/irritated skin alongside a treatable concern (active acne,
      // texture, or marks). Renders below the AM/PM routine so it reads as
      // an instruction, not a warning. Engine flag: persona.barrier_first.
      barrier_first: {
        eyebrow: "Important for sensitive skin",
        heading: "Start with the basics for the first 2 weeks",
        body: "You told us your skin reacts often. Before introducing the actives in your routine, run only the cleanser (BSC) and moisturiser for at least 2 weeks. This gives your barrier time to strengthen and improves how well your skin tolerates the actives later. Once your skin feels settled, add one active at a time, with a few days between each. If anything stings or flares, message us on WhatsApp before continuing."
      },

      section_products: "Your products",
      section_products_lead: "Every product here has a specific job to do. Tap 'Why' to see exactly what it does for your skin.",
      section_routine:  "Your AM / PM routine",
      section_routine_lead: "Step by step, in the right order. Morning and night.",
      section_expect: "What to expect",
      section_expect_lead: "Honest, week by week. Skin takes time. Here's what that actually looks like.",
      section_faq: "Questions, answered",
      section_reviews: "Hear from others",
      section_reviews_lead: "From people whose skin sounds a lot like yours.",
      reviews_placeholder: "Reviews will appear here once connected to your review app.",

      add_all_cta: "Add full routine to cart",
      sticky_cta: "Add full routine to cart",
      sticky_label: "Your routine total",
      edit_answers: "Update my answers",
      empty_state_h: "No routine found yet",
      empty_state_p: "Take our 60-second skin quiz and we'll build one for you.",
      empty_state_cta: "Take the quiz",

      // =========================================================
      // Personalized top-of-page blocks (acknowledgement + plan)
      // ---------------------------------------------------------
      // These are template-based for now. If the personalization
      // ever feels too generic, swap to an LLM-written version at
      // quiz completion (stored alongside the persona).
      // =========================================================
      // ---------------------------------------------------------
      // Plan section (Section 2 on the PDP). "Jobs-based" framing.
      // Renderer reads jobs from TSSQuizEngine.buildJobs(persona).
      // ---------------------------------------------------------
      jobs_section: {
        eyebrow: "Your plan",
        // {count} replaced with number of job lines
        heading_one:   "One thing this routine does for you",
        heading_multi: "{count} things this routine does for you",
        intro_multi_active: "Your routine includes two active products, we'll introduce them gradually. Start with one. Add the second after your skin has adjusted. If you're unsure when to add the second, message us on WhatsApp and we'll guide you.",
        promise_with_rcf:    "After you order, you'll have a direct WhatsApp line to our team. If anything comes up while you're using the routine, we're here to help.",
        promise_without_rcf: "After you order, you'll have a direct WhatsApp line to our team. If anything comes up while you're using the routine, we're here to help."
      },

      // ---------------------------------------------------------
      // Product group labels (Section 3). Displayed above each
      // group of cards. Kept subtle and factual.
      // ---------------------------------------------------------
      product_groups: {
        treatment: "The treatments",
        support:   "The supporting cast",
        addon:     "Optional add-ons"
      },

      acknowledgement: {
        eyebrow: "Here's what we're working with",
        // Keyed by the primary concern story. Engine picks first match.
        // Tokens: {skin}, {freqPhrase} (may be empty string).
        templates: {
          fungal:       "Fungal acne on {skin} skin. These uniform, stubborn bumps don't respond to regular acne treatment, and most routines actually make them worse before they get better. Your skin needs a different approach, not a stronger one.",
          rosacea:      "Rosacea-prone {skin} skin. It flushes, it reacts, it stays red longer than it should. The last thing it needs is more aggression, so we've built the opposite.",
          irritation:   "Sensitive, reactive {skin} skin. If most products sting and many leave your skin worse, your barrier is asking to be looked after first, before any actives come in.",
          marks_acne:   "Active breakouts and the marks from the old ones, on {skin} skin. That's a double job, clearing what's flaring now and fading what's already settled in. We've accounted for both.",
          texture_acne: "Breakouts and texture together, on {skin} skin. Same root cause (clogged pores), showing up two different ways. So the plan works both angles.",
          active_acne:  "Active breakouts on {skin} skin{freqPhrase}. Nothing about this is quick, and it's exhausting when something keeps coming back no matter what you try. This routine is built to change that.",
          marks:        "The marks left behind on {skin} skin after breakouts have healed. The skin has recovered. The reminders haven't, and you want them gone.",
          texture:      "Blackheads and uneven texture on {skin} skin. Not painful, not angry, but persistent, and most cleansers don't actually shift it.",
          maintenance:  "{skin} skin in a steady place, and you want to keep it there. That's a good starting point, most people come to us with a lot more going on."
        }
      },

      // Prescription-feel plan card, sits just below the acknowledgement.
      plan: {
        eyebrow: "Your plan",
        // Tokens: {count}
        heading_single:    "{count} products, used daily. Nothing extra.",
        heading_multi:     "{count} products, introduced over the first 2 weeks so your skin has time to adjust.",
        heading_default:   "{count} products, used morning and evening.",
        am_label: "Morning",
        pm_label: "Evening",
        // Short line above AM/PM lists to give the plan a prescription feel.
        rx_note: "Use as directed below. Consistency matters more than anything else."
      },

      // Short, 1-2 line personalised WHY shown above each product's collapsible deep WHY.
      // Must read on its own. The deep WHY (keyed the same way in `why` above) handles the details.
      why_short: {
        RCF: {
          active_acne: "For the inflamed breakouts you're dealing with right now.",
          marks:       "Clears the active breakouts that create new marks, so you stop adding to the problem.",
          spot:        "Your spot-treatment option. Works on contact when a pimple appears.",
          dry:         "Set to once-daily or SOS use, effective without wrecking your barrier."
        },
        BSC: {
          daily:      "Your gentle everyday cleanse. Cleans without stripping.",
          irritation: "A cleanser that actually calms instead of provoking.",
          pair:       "Used on your gentler cleansing days, keeps your barrier steady in between."
        },
        USDC: {
          texture:     "Clears the clogged pores behind blackheads and uneven texture.",
          texture_dry: "Texture care on alternate days, so your barrier stays intact.",
          maintenance: "Keeps pores clear so breakouts don't creep back in."
        },
        SFARS: {
          marks:           "Fades the marks left behind. Gradually, and without bleaching.",
          fungal_rosacea:  "The anti-inflammatory active your skin can actually tolerate.",
          active_acne:     "Fades post-acne marks before they set in."
        },
        BRGM: { default: "Lightweight barrier repair. Hydrates without clogging." },
        BRIM: { default: "Rich, non-comedogenic hydration built for dry, acne-prone skin." },
        SS: {
          active_use: "SPF 50+ that doesn't break you out or leave a white cast.",
          marks:      "SPF 50+, because UV undoes every bit of mark-fading progress.",
          sensitive:  "SPF 50+, fragrance-free, gentle enough for reactive skin.",
          default:    "SPF 50+, encapsulated filters. No white cast, no breakouts."
        }
      },

      // Standalone EMC add-on card (shown below Add-full-routine CTA, outside the bundle).
      // Surfaces EMC to users who might wear makeup, without forcing it into the bundled routine.
      emc_addon: {
        eyebrow: "Optional add-on",
        heading: "Wear makeup? Add this to your routine.",
        body: "Makeup, SPF and daily grime settle into pores through the day. A regular cleanser doesn't always get them fully out, and any residue sits between your actives and your skin. Effortless Melting Cleanser dissolves all of it in one pass, foundation, waterproof mascara, every layer of SPF, so the rest of your routine actually reaches clean skin. Use it at night as your first step, before your regular cleanse.",
        cta_add: "Add to cart",
        cta_added: "✓ Added"
      },

      // Standalone BSC add-on card (shown outside the bundle when BSC is offered
      // as optional: the routine has no other cleanser, or skin runs sensitive).
      // The body explains WHY a gentle cleanser matters, especially for reactive skin.
      bsc_addon: {
        eyebrow: "Optional add-on",
        heading: "Add a gentle cleanser.",
        body: "Your routine works best on skin that's cleansed without being stripped. Barrier Soothing Cleanser is the gentlest wash we make: 50% glycerin with ceramides and cica, no sulfates, no fragrance. It cleans while keeping your moisture barrier intact, which matters most when your skin runs sensitive or reactive, or when you're using actives that can leave it feeling tight. Use it in the morning, or on the days your skin needs a softer wash. If you already have a gentle cleanser you trust, you can use that instead.",
        cta_add: "Add to cart",
        cta_added: "✓ Added"
      },

      // Two timeline variants. tss-quiz-pdp.js picks the right one based on
      // whether RCF is in the persona's recommended products.
      timeline_with_rcf: [
        { week: "Week 1",   what: "Your skin is getting used to the routine. A little tingling from Rapid Clear Facewash is normal, it means it's doing its job. Hydration usually improves first." },
        { week: "Week 2–3", what: "Active breakouts start settling. Some people notice a brief increase in surface pimples around this time. This is your skin clearing from the inside out, not a sign something's wrong." },
        { week: "Week 4",   what: "Fewer new breakouts. Texture begins to smooth. The earliest signs of marks starting to fade." },
        { week: "Week 8+",  what: "Visibly clearer, more even skin. With consistent use, marks continue to lighten." }
      ],
      timeline_without_rcf: [
        { week: "Week 1",   what: "Your skin starts settling into the routine. Most people notice improved comfort, less dryness, less reactivity, within the first few days." },
        { week: "Week 2–3", what: "Skin feels calmer and more balanced. Redness and sensitivity begin to ease. Marks may start looking a little more even." },
        { week: "Week 4",   what: "Texture improving. With consistent serum use, marks are noticeably lighter." },
        { week: "Week 8+",  what: "A more even skin tone, continued fading of marks, and a steadier, calmer baseline overall." }
      ],

      // FAQ. Purging question is ONLY shown when RCF is in the bundle.
      faq: [
        { q: "Is this safe for my skin?",     a: "Every product in your routine is formulated and tested for acne-prone skin. The ingredients are dosed appropriately for the concerns you've shared. If you have a known sensitivity to any ingredient, a quick patch test before you start is always a good idea." },
        { q: "What if I don't see results?",  a: "Real skin change takes time. Most active ingredients need 6 to 8 weeks of consistent use to show meaningful improvement. If you're not seeing progress by Week 8, reach out to our team. We'll review your routine and recommend adjustments." },
        { q: "Is purging normal?",            a: "In the first 1 to 3 weeks of starting a new active treatment, some people see a temporary uptick in surface pimples. This is your skin clearing congestion from the inside out. It's a different thing to irritation. Purging tends to happen where you'd already break out. If your skin feels red, itchy, or reacts somewhere new, message us, we'll help you figure out what's going on.", when_rcf_only: true }
      ]
    },

    // =========================================================
    // WHY TEMPLATES (shown inside each product card)
    // =========================================================
    why: {
      // PER-PRODUCT ISOLATION RULE: every WHY here only talks about this one product.
      // No cross-product mentions. Personalization is by skin / concern / frequency only.
      RCF: {
        active_acne: "Breakouts happen when pores get clogged and acne-causing bacteria multiply under the skin. Rapid Clear Facewash uses Micronized Benzoyl Peroxide, particles fine enough to get deep into pores and eliminate 93% of acne-causing bacteria in under a minute. In clinical testing, it reduced acne and visible redness within the first week. (Based on in-vivo clinical study, UKAS approved independent lab, 2025. Individual results may vary.)",
        marks: "Rapid Clear Facewash clears breakouts at the source, which is where new marks start. Stopping the cycle here means fewer fresh marks to deal with down the line.",
        spot: "For the occasional pimple, Rapid Clear Facewash works on contact. Apply directly as a spot treatment. The Micronized BPO gets to work within minutes.",
        dry: "On drier skin, we've set Rapid Clear Facewash for once-daily or spot-treatment use. So you get effective acne-clearing power without it working against your skin's moisture balance."
      },
      BSC: {
        daily: "A pH-balanced, non-stripping cleanser that removes what needs to go without disturbing your skin's natural balance. The right base for almost every routine.",
        irritation: "When skin is reactive, even the cleanser matters. Barrier Soothing Cleanser is gentle enough for sensitised skin. It cleans thoroughly without tipping things further.",
        pair: "Barrier Soothing Cleanser handles your gentler cleansing days. Non-stripping, pH-balanced, it keeps your barrier supported so your skin stays steady in between."
      },
      USDC: {
        texture: "Works directly on the congestion that causes blackheads and bumpy texture. Clears it out without stripping your skin in the process.",
        texture_dry: "On drier skin, we've set USDC for alternate-day use. So you get the texture-clearing benefit without over-cleansing.",
        maintenance: "Keeps skin clear between breakouts. A steady daily cleanse that stops congestion from quietly building up."
      },
      SFARS: {
        marks: "SpotFade uses fully solubilised azelaic acid, one of the most clinically supported ingredients for fading post-acne marks. It works gradually and consistently. The key is not skipping it.",
        fungal_rosacea: "Azelaic acid is particularly well-suited to skin dealing with fungal acne or rosacea. It addresses discolouration while staying anti-inflammatory. Gentle enough for daily use.",
        active_acne: "SpotFade uses solubilised azelaic acid to calm the inflammation breakouts leave behind and fade post-acne marks before they set in. Works gradually, the key is consistency."
      },
      BRGM: {
        default: "After active ingredients, your skin needs barrier repair. BRGM is lightweight and non-greasy. 1% ceramide complex, niacinamide, and cica calm, hydrate, and strengthen without clogging oily or combo skin."
      },
      BRIM: {
        default: "Dry skin on an acne routine needs extra hydration. BRIM is rich but non-comedogenic. Ceramides, panthenol, hyaluronic acid, and squalane repair your barrier and keep skin soft while actives do their work."
      },
      // Sunscreen WHY: isolated — describes Clear Protect only, no references to other products.
      // Variants tune the angle (active use, pigmentation, sensitivity) without naming other products.
      SS: {
        active_use: "When you're on active ingredients, your skin becomes more sensitive to UV. Clear Protect Gel Sunscreen (SPF 50+, PA++++) shields it without adding weight. Ceramides support your barrier through treatment. Matte finish, no white cast.",
        marks: "UV is the single biggest thing that slows down mark fading, and can deepen existing pigmentation. Clear Protect Gel Sunscreen (SPF 50+, PA++++) protects against that. Niacinamide in the formula works quietly on tone over time. Matte, no white cast.",
        sensitive: "Sensitised skin reacts to UV stress just like anything else. Clear Protect Gel Sunscreen's ceramide-rich, fragrance-free formula protects without provocation. SPF 50+, PA++++, zero white cast.",
        default: "Sun protection is non-negotiable on an acne routine. UV triggers PIH, the same marks you don't want. Clear Protect Gel Sunscreen is SPF 50+, PA++++ with encapsulated hybrid filters. No white cast, no breakouts, full protection."
      },
      EMC: {
        default: "Makeup residue is a top cause of clogged pores in acne-prone skin. EMC melts everything. Foundation, SPF, waterproof mascara. So your treatment actually reaches clean skin."
      }
    }
  };
})();
